import { Box, Button, Flex, IconButton, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { MdArrowBack, MdArrowForward } from "react-icons/md";
import { CATEGORIES_STEPS } from "../../const";
import { useDispatch } from "react-redux";
import { setAction } from "../../../../../../context/Store/slices/questionnaireSlice";
import { CHANGE_ACTIONS } from "../Steps/TabStepsPanels";

function CategoryNavigation({ shouldShowPrev, shouldShowNext, currentIndex, formId, categories }) {
  const dispatch = useDispatch();
  const prevIndex = CATEGORIES_STEPS.indexOf(categories[currentIndex - 1]) + 1;
  const nextIndex = CATEGORIES_STEPS.indexOf(categories[currentIndex + 1]) + 1;

  return (
    <Flex
      borderBlockStartWidth="thin"
      alignItems="center"
      paddingBlockStart="4"
      paddingBlockEnd="2"
    >
      <Box flexGrow="1">
        {shouldShowPrev && (
          <CategoryNavigationButton
            onClick={() => dispatch(setAction(CHANGE_ACTIONS.PREV))}
            form={formId}
            index={prevIndex}
            isPrev
          />
        )}
      </Box>
      <Box flexGrow="1" display="flex" justifyContent="flex-end">
        {shouldShowNext && <CategoryNavigationButton
          onClick={() => dispatch(setAction(CHANGE_ACTIONS.NEXT))}
          form={formId}
          index={nextIndex}
        />}
      </Box>
    </Flex>
  );
}

function CategoryNavigationButton({ isPrev = false, index, ...rest }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "organizationQuestionnaire.scope3.categories",
  });

  return (
    <Button
      variant="unstyled"
      type="submit"
      _focus={{ outline: "none", textDecoration: "underline" }}
      {...rest}
    >
      <Flex alignItems="center" gap="4">
        <IconButton
          variant="outline"
          borderRadius="full"
          as="div"
          icon={isPrev ? <MdArrowBack /> : <MdArrowForward />}
          order={isPrev ? 1 : 2}
        />
        <Box textAlign={isPrev ? "start" : "end"} order={isPrev ? 2 : 1}>
          <Text
            as="strong"
            opacity="0.5"
            textTransform="uppercase"
            fontSize="xs"
          >
            {t("saveAndGoTo")}
          </Text>
          <Text fontWeight="bold">{t("label", { value: index })}</Text>
        </Box>
      </Flex>
    </Button>
  );
}

export default CategoryNavigation;
